import { render, staticRenderFns } from "./tobe_ofd.vue?vue&type=template&id=0efd4358&"
import script from "./tobe_ofd.vue?vue&type=script&lang=js&"
export * from "./tobe_ofd.vue?vue&type=script&lang=js&"
import style0 from "./tobe_ofd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports